"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _RestClient = _interopRequireDefault(require("./RestClient"));

var _mediaLibrary = _interopRequireDefault(require("./admin/mediaLibrary"));

var _user = _interopRequireDefault(require("./admin/user"));

var _home = _interopRequireDefault(require("./admin/home"));

var _company = _interopRequireDefault(require("./admin/company"));

var _entity = _interopRequireDefault(require("./admin/entity"));

var _account = _interopRequireDefault(require("./admin/account"));

var _Analytics = _interopRequireDefault(require("./admin/Analytics"));

var _sitecopy = _interopRequireDefault(require("./admin/sitecopy"));

var _teams = _interopRequireDefault(require("./admin/teams"));

var _coachList = _interopRequireDefault(require("./admin/coachList"));

var _clientsList = _interopRequireDefault(require("./admin/clientsList"));

var _coachClient = _interopRequireDefault(require("./admin/coachClient"));

var _coachPlan = _interopRequireDefault(require("./admin/coachPlan"));

var _promoCode = _interopRequireDefault(require("./admin/promoCode"));

var _EmailSequencing = _interopRequireDefault(require("./admin/EmailSequencing"));

var _payment = _interopRequireDefault(require("./admin/payment"));

var _common = _interopRequireDefault(require("./admin/common"));

var _survey = _interopRequireDefault(require("./admin/survey"));

var _quests = _interopRequireDefault(require("./admin/quests"));

var _report = _interopRequireDefault(require("./admin/report"));

var _scheduling = _interopRequireDefault(require("./admin/scheduling"));

var _zoom = _interopRequireDefault(require("./admin/zoom"));

// import EcoSystem from './admin/ecosystem'
var Admin = /*#__PURE__*/(0, _createClass2["default"])(function Admin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck2["default"])(this, Admin);
  var restClient = new _RestClient["default"]({
    baseUrl: options.baseUrl
  });
  this.mediaLibrary = new _mediaLibrary["default"](restClient);
  this.userList = new _user["default"](restClient);
  this.companyList = new _company["default"](restClient);
  this.home = new _home["default"](restClient);
  this.account = new _account["default"](restClient);
  this.siteCopy = new _sitecopy["default"](restClient);
  this.analytics = new _Analytics["default"](restClient);
  this.teams = new _teams["default"](restClient);
  this.coachingList = new _coachList["default"](restClient);
  this.clientsList = new _clientsList["default"](restClient);
  this.coachClient = new _coachClient["default"](restClient);
  this.coachPlan = new _coachPlan["default"](restClient); // this.ecoSystem = new EcoSystem(restClient)

  this.promo = new _promoCode["default"](restClient);
  this.emailSequencing = new _EmailSequencing["default"](restClient);
  this.payment = new _payment["default"](restClient);
  this.common = new _common["default"](restClient);
  this.survey = new _survey["default"](restClient);
  this.quests = new _quests["default"](restClient);
  this.entityService = new _entity["default"](restClient);
  this.report = new _report["default"](restClient);
  this.scheduling = new _scheduling["default"](restClient);
  this.zoom = new _zoom["default"](restClient);
});
exports["default"] = Admin;